export const CDN_BASE_URL = import.meta.env.VITE_CDN_BASE_URL || "";

if (!CDN_BASE_URL && import.meta.env.PROD) {
  console.error("[constants] VITE_CDN_BASE_URL is not set — image resizing will be disabled");
}

/**
 * Public origin used when constructing branded share URLs (`/s/:id`).
 * Set per-environment via VITE_SITE_URL (e.g. https://app.todowith.ai in prod,
 * the Vercel preview URL in dev). Falls back to the current origin in the
 * browser so local dev "just works" without any env config.
 */
export const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL as string | undefined)?.trim() ||
  (typeof window !== "undefined" ? window.location.origin : "");

if (!SITE_URL && import.meta.env.PROD) {
  console.error("[constants] VITE_SITE_URL is not set — share links will be relative");
}

export const MAX_REFERENCE_IMAGES = 5;
export const AVATAR_URL_PREFIX = "https://api.dicebear.com/7.x/initials/svg";
export const SUPPORT_EMAIL = "team@todowith.ai";
export const WHATSAPP_NUMBER = "972542064301";

/**
 * Invite link to our quiet WhatsApp community group (tips, tricks, discounts,
 * beta access). Distinct from `WHATSAPP_NUMBER`, which is the 1:1 admin chat
 * used for direct support / error reports.
 */
export const WHATSAPP_COMMUNITY_URL =
  "https://chat.whatsapp.com/EBaZ1MpZCmZGrEKthgjZxQ?mode=gi_t";

/** Auto-fail pending generations older than this (10 minutes) */
export const STALE_GENERATION_TIMEOUT_MS = 10 * 60 * 1000;

/** sessionStorage key prefix for persistent pending boost counters */
export const PENDING_BOOST_STORAGE_PREFIX = "flowly-pending";

/** How long to show the 100% "Done!" state before removing the card */
export const COMPLETION_ANIMATION_MS = 1500;

/** Estimated generation durations for progress bar calculation */
export const ESTIMATED_GENERATION_DURATION_MS = {
  image: 60 * 1000,
  video: 120 * 1000,
} as const;
